/* eslint-disable @typescript-eslint/no-non-null-assertion */
import isDesktop from '@lib/is-desktop';

let metaMenuElement: null | HTMLDivElement = null;

export default function getMetaMenu(): HTMLDivElement | null {
    return metaMenuElement;
}

export function initMetaMenu(): HTMLDivElement | null {
    metaMenuElement = document.getElementById('meta-menu') as HTMLDivElement | null;
    if (!metaMenuElement) throw new Error('Could not find element with meta-menu id!');
    const metaMenuParent = metaMenuElement.parentElement!;

    window.addEventListener('resize', () => {
        if (isDesktop()) {
            metaMenuParent?.appendChild(metaMenuElement!);
        }
    });

    return metaMenuElement;
}
